import 'select2/dist/js/select2';

export default class Select {
    constructor() {
        this.bindUIActions();
    }

    applySelectStyles() {
        const selectOptions = {
            minimumResultsForSearch: Infinity,
            width: 'resolve'
        };

        // Set options to select and `Gravity Forms` select inputs
        $('.js-select, .gfield_select').select2(selectOptions);

        // Set select container to full-width
        $('.select2-container').css('width', '100%');
    }

    bindUIActions() {
        // Apply `Select2` styles on page load
        this.applySelectStyles();

        // Add a method to reinitialize `Select2` styles after form submission
        this.handleFormEvents();
    }

    handleFormEvents() {
        // Listen for both `submit` and `gform_post_render` events and re-apply `Select2` styles
        $(document).on('submit gform_post_render', () => {
            this.applySelectStyles();
        });
    }
}

new Select();

